'use strict'
module.exports = {
    videoPosterPrefix: 'addPanelData/sections/videos_en/sliderGalleries/gallery-video-thumb-sliders-',
    videoSrcPrefix: 'v1/gallery-video-thumb-slider-'
}
